module.exports = __webpack_public_path__ + "img/level3.8bc3b0f5.png";